module.exports = __webpack_public_path__ + "static/tebi-12d3994e3717599099b8095605179335.webp";